import { TOKEN_KEY, apiURL } from "./api";
import { triggerSessionExpiration } from "utils/sessionManager";

// export const apiURL = "http://localhost:3589";
// export const apiURL = "https://galaxybis.ebudgetkano.ng/katsina-server";

export const fetchApi = async (url) => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);

    const request = await fetch(`${apiURL}/${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
      },
    });

    // Check for 401 status - user will be logged out by fetch interceptor
    if (request.status === 401) {
      triggerSessionExpiration();
      throw new Error("Session expired");
    }

    const response = await request.json();

    // Check response body for 401 status
    if (response.status === 401) {
      triggerSessionExpiration();
      throw new Error("Session expired");
    }

    return response;
  } catch (error) {
    // If session expired, don't return error, just throw
    if (error.message === "Session expired") {
      throw error;
    }
    return error;
  }
};

export const postApi = async (url, data = {}) => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);

    const request = await fetch(`${apiURL}/${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    });

    // Check for 401 status - user will be logged out by fetch interceptor
    if (request.status === 401) {
      triggerSessionExpiration();
      throw new Error("Session expired");
    }

    const response = await request.json();

    // Check response body for 401 status
    if (response.status === 401) {
      triggerSessionExpiration();
      throw new Error("Session expired");
    }

    return response;
  } catch (error) {
    // If session expired, don't return error, just throw
    if (error.message === "Session expired") {
      throw error;
    }
    return error;
  }
};

export const deleteApi = async (url, data = {}) => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    const request = await fetch(`${apiURL}/${url}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
      },
      body: data ? JSON.stringify(data) : null,
    });

    // Check for 401 status - user will be logged out by fetch interceptor
    if (request.status === 401) {
      triggerSessionExpiration();
      throw new Error("Session expired");
    }

    const response = await request.json();

    // Check response body for 401 status
    if (response.status === 401) {
      triggerSessionExpiration();
      throw new Error("Session expired");
    }

    return response;
  } catch (error) {
    // If session expired, don't return error, just throw
    if (error.message === "Session expired") {
      throw error;
    }
    return error;
  }
};

export const updateApi = async (url = "", data = []) => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    const request = await fetch(`${apiURL}/${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    });

    // Check for 401 status - user will be logged out by fetch interceptor
    if (request.status === 401) {
      triggerSessionExpiration();
      throw new Error("Session expired");
    }

    const response = await request.json();

    // Check response body for 401 status
    if (response.status === 401) {
      triggerSessionExpiration();
      throw new Error("Session expired");
    }

    return response;
  } catch (error) {
    // If session expired, don't return error, just throw
    if (error.message === "Session expired") {
      throw error;
    }
    return error;
  }
};

function unflatten(arr) {
  var tree = [],
    mappedArr = {},
    arrElem,
    mappedElem;
  for (var i = 0, len = arr.length; i < len; i++) {
    arrElem = arr[i];
    mappedArr[arrElem.title] = arrElem;
    mappedArr[arrElem.title]["children"] = [];
  }

  for (var title in mappedArr) {
    if (mappedArr.hasOwnProperty(title)) {
      mappedElem = mappedArr[title];
      if (mappedElem.subhead) {
        mappedArr[mappedElem["subhead"]]["children"].push(mappedElem);
      } else {
        tree.push(mappedElem);
      }
    }
  }
  return tree;
}

export { unflatten, apiURL };
